var path = '/Users/linda/git/Sunflower/prisms-crt/prisms-client-components-ng/src/containers/policy-editor/add-constraints/add-constraints.html';
var html = "<form class=\"policy-add-constraints form\">\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;